import { html } from '@design.estate/dees-element';

export function demoFunc() {
  return html`
    <dees-heading level="1">This is a H1 heading</dees-heading>
    <dees-heading level="2">This is a H2 heading</dees-heading>
    <dees-heading level="3">This is a H3 heading</dees-heading>
    <dees-heading level="4">This is a H4 heading</dees-heading>
    <dees-heading level="5">This is a H5 heading</dees-heading>
    <dees-heading level="6">This is a H6 heading</dees-heading>
    <dees-heading level="hr">This is an hr heading (level="hr")</dees-heading>
    <dees-heading level="7">This is an hr heading (level="7")</dees-heading>
    <dees-heading level="hr-small">This is an hr-small heading (level="hr-small")</dees-heading>
    <dees-heading level="8">This is an hr-small heading (level="8")</dees-heading>
  `;
}